// extracted by mini-css-extract-plugin
export var container = "_cg-1";
export var cornerButtonContainer = "_cg-6";
export var disabled = "_cg-2";
export var dragActive = "_cg-3";
export var fileContainer = "_cg-5";
export var hiddenInput = "_cg-4";
export var widthContainer = "_cg-0";